import React, { useEffect } from "react";
import NewPeriodDialog from "./NewPeriodDialog";
import { useGameContextContext } from "../../../state/game-context/context";
import { useTeamsContext } from "../../../state/teams/context";

const NewPeriodNotification = () => {
	const { state, swapTeams, handlePeriodTransition, updateOffensiveTeam } =
		useGameContextContext();
	const period = state.period();
	const triggerNewPeriodNotification = state.triggerNewPeriodNotification();
	const promptReceivingTeam = state.promptReceivingTeam();
	const areTeamsSwapped = state.swapTeams();
	const isOvertime = state.overtimePeriod();
	const { state: teamState } = useTeamsContext();
	const homeTeam = teamState.homeTeam();
	const awayTeam = teamState.awayTeam();
	const homeTeamHasPossession = state.homeTeamHasPossession();

	useEffect(() => {
		handlePeriodTransition();
	}, [period]);

	const handleClose = () => {
		swapTeams(!areTeamsSwapped);
	};

	return (
		<NewPeriodDialog
			isOpen={triggerNewPeriodNotification && promptReceivingTeam && !isOvertime}
			onClose={handleClose}
			homeTeam={homeTeam}
			awayTeam={awayTeam}
			homeTeamHasPossession={homeTeamHasPossession}
			onReceivingTeamChange={updateOffensiveTeam}
		/>
	);
};

export default NewPeriodNotification;
